import React from "react";
import { Route, Routes as ReactRoutes, Navigate } from "react-router-dom";
import Index from "./Partials/Universal/Dashboard/Index";
import MyProfile from "./Partials/MyProfile/MyProfile";
import Hotels from "./Partials/Universal/Hotels/Hotels";
import RoomBooking from "./Partials/Universal/Hotels/Components/RoomBooking/RoomBooking";
import RoomFacilitesList from "./Partials/Universal/Hotels/Components/RoomFacilitesList/RoomFacilitesList";
import HouseKeepingAssignRoom from "./Partials/Universal/Hotels/Components/HouseKeepingAssignRoom/HouseKeepingAssignRoom";
import CabList from "./Partials/Universal/Hotels/Components/CabList/CabList";
import ItemsList from "./Partials/Universal/Hotels/Components/ItemsList/ItemsList";
import Personalised from "./Partials/Universal/Hotels/Components/Personalised/Personalised";
import JacuzziBooking from "./Partials/Universal/Hotels/Components/JacuzziBooking/JacuzziBooking";
import BookingReport from "./Partials/Universal/Hotels/Components/BookingReport/BookingReport";
import PromocodeList from "./Partials/Universal/Hotels/Components/PromocodeList/PromocodeList";
import Transaction from "./Partials/Universal/Transaction/Transaction";
import BookingList from "./Partials/Universal/RoomBook/Components/BookingList/BookingList";
import RoomCheckout from "./Partials/Universal/RoomBook/Components/RoomCheckout/RoomCheckout";
import RoomStatus from "./Partials/Universal/RoomBook/Components/RoomStatus/RoomStatus";
import FacilitesDetailsList from "./Partials/Universal/RoomFacilites/Components/FacilitesDetailsList/FacilitesDetailsList";
import RoomSize from "./Partials/Universal/RoomFacilites/Components/RoomSize/RoomSize";
import RoomCleaning from "./Partials/Universal/HouseKeeping/Components/RoomCleaning/RoomCleaning";
import Checklist from "./Partials/Universal/HouseKeeping/Components/Checklist/Checklist";
import QrList from "./Partials/Universal/HouseKeeping/Components/QrList/QrList";
import CleaningReport from "./Partials/Universal/HouseKeeping/Components/CleaningReport/CleaningReport";
import CabBooking from "./Partials/Universal/CabFacility/Components/CabBooking/CabBooking";
import ItemsUnitList from "./Partials/Universal/ItemsManage/Components/ItemsUnitList/ItemsUnitList";
import ItemsDestroyed from "./Partials/Universal/ItemsManage/Components/ItemsDestroyed/ItemsDestroyed";
import ItemsCategory from "./Partials/Universal/ItemsManage/Components/ItemsCategory/ItemsCategory";
import ItemsSuppliers from "./Partials/Universal/ItemsManage/Components/ItemsSuppliers/ItemsSuppliers";
import SwimmingPool from "./Partials/Universal/Personalised/Components/SwimmingPool/SwimmingPool";
import Spa from "./Partials/Universal/Personalised/Components/Spa/Spa";
import Pedicure from "./Partials/Universal/Personalised/Components/Pedicure/Pedicure";
import Theater from "./Partials/Universal/Personalised/Components/Theater/Theater";
import Banquet from "./Partials/Universal/Personalised/Components/Banquet/Banquet";
import AllSettings from "./Partials/Universal/Personalised/Components/AllSettings/AllSettings";
import PurchaseReports from "./Partials/Reports/Components/PurchaseReports/PurchaseReports";
import Invoice from "./Partials/Reports/Components/PurchaseReports/Components/Invoice";
import StockReport from "./Partials/Reports/Components/StockReport/StockReport";
import BedList from "./Partials/RoomsSettings/Components/BedList/BedList";
import BookingTypeList from "./Partials/RoomsSettings/Components/BookingTypeList/BookingTypeList";
import BookingCommission from "./Partials/RoomsSettings/Components/BookingCommission/BookingCommission";
import ComplementaryList from "./Partials/RoomsSettings/Components/ComplementaryList/ComplementaryList";
import FloorPlanList from "./Partials/RoomsSettings/Components/FloorPlanList/FloorPlanList";
import RoomList from "./Partials/RoomsSettings/Components/RoomList/RoomList";
import RoomType from "./Partials/RoomsSettings/Components/RoomType/RoomType";
import RoomImages from "./Partials/RoomsSettings/Components/RoomImages/RoomImages";
import IndexHr from "./Hrms/Usual/HRDashboard/IndexHr";
import Hrms from "./Hrms/Usual/HRMS/Hrms";
import AddEmployees from "./Hrms/Usual/HRMS/Components/AddEmployees/AddEmployees";
import LeaveRequest from "./Hrms/Usual/HRMS/Components/LeaveRequest/LeaveRequest";
import EmployeeProfile from "./Hrms/Usual/HRMS/Components/LeaveRequest/Components/EmployeeProfile";
import AssignedEmployeeList from "./Hrms/Usual/HRMS/Components/AssignedEmployeeList/AssignedEmployeeList";
import Attendance from "./Hrms/Usual/HRMS/Components/Attendance/Attendance";
import EmployeeSalary from "./Hrms/Usual/HRMS/Components/EmployeeSalary/EmployeeSalary";
import PayrollReport from "./Hrms/Usual/HRMS/Components/PayrollReport/PayrollReport";
import EmployeesDepartments from "./Hrms/Usual/HRMS/Components/EmployeesDepartments/EmployeesDepartments";
import ShiftList from "./Hrms/Usual/DutyChanges/Components/ShiftList/ShiftList";
import RosterList from "./Hrms/Usual/DutyChanges/Components/RosterList/RosterList";
import AllEmployees from "./Hrms/Employees/AllEmployees/AllEmployees";
import EmployeeLoan from "./Hrms/Employees/EmployeeLoan/EmployeeLoan";
import EmployeeAppraisal from "./Hrms/Employees/EmployeeAppraisal/EmployeeAppraisal";
import PaySlip from "./Hrms/PayRoll/PaySlip/PaySlip";
import Tuning from "./Tuning/Configuration/Components/Tuning/Tuning";
import CommonSettings from "./Tuning/Configuration/Components/Tuning/Components/CommonSettings/CommonSettings";
import PaymentSettings from "./Tuning/Configuration/Components/Tuning/Components/PaymentSettings/PaymentSettings";
import AccountSettings from "./Tuning/Configuration/Components/Tuning/Components/AccountSettings/AccountSettings";
import RoleAdd from "./Tuning/Configuration/Components/Tuning/Components/RoleAdd/RoleAdd";
import Apps from "./Tuning/Configuration/Components/Tuning/Components/Apps/Apps";
import Inbox from "./Tuning/Configuration/Components/Tuning/Components/Apps/Components/Inbox/Inbox";
import Chat from "./Tuning/Configuration/Components/Tuning/Components/Apps/Components/Chat/Chat";
import Calendar from "./Tuning/Configuration/Components/Tuning/Components/Apps/Components/Calendar/Calendar";
import FileManager from "./Tuning/Configuration/Components/Tuning/Components/Apps/Components/FileManager/FileManager";
import Changelog from "./Tuning/Configuration/Components/Tuning/Components/Apps/Components/Changelog/Changelog";
import RoleList from "./Tuning/RoleManagement/RoleList/RoleList";
import RolePermission from "./Tuning/RoleManagement/RolePermission/RolePermission";
import RoleCreate from "./Tuning/RoleManagement/RoleCreate/RoleCreate";
import RoleAssign from "./Tuning/RoleManagement/RoleAssign/RoleAssign";
import RoleAccess from "./Tuning/RoleManagement/RoleAccess/RoleAccess";
import AboutUs from "./Tuning/FrontPages/AboutUs/AboutUs";
import ContactUs from "./Tuning/FrontPages/ContactUs/ContactUs";
import PrivacyPolicy from "./Tuning/FrontPages/PrivacyPolicy/PrivacyPolicy";
import TermsConditions from "./Tuning/FrontPages/TermsConditions/TermsConditions";
import Blog from "./Tuning/Application/Blog/Blog";
import BlogDetail from "./Tuning/Application/BlogDetail/BlogDetail";
import SearchPage from "./Tuning/Pages/SearchPage/SearchPage";
import CalendarView from "./Partials/Universal/CalendarView/CalendarView";
import RoomView from "./Partials/Universal/RoomView/RoomView";
import GuestDatabase from "./Partials/Universal/GuestDatabase/GuestDatabase";
import NightAudit from "./Partials/Universal/NightAudit/NightAudit";
import EditGuestDatabase from "./Partials/Universal/GuestDatabase/Components/EditGuest";
import POS from "./Partials/Universal/POS/Components/POS";
import KOT from "./Partials/Universal/POS/Components/KOT";
import Revenue from "./Partials/Universal/POS/Components/Revenue";
import Reports from "./Partials/Universal/Reports/Reports";
import HRMSDashboard from "./Hrms/HRMSDashboard/HRMSDashboard";
import SubAttendance from "./Hrms/SubAttendance/SubAttendance";
import LiveLogs from "./Hrms/LiveLogs/LiveLogs";
import DutyRoster from "./Hrms/DutyRoster/DutyRoster";
import Audit from "./Hrms/Audit/Audit";
import AddNewEmployee from "./Hrms/Employees/AddNewEmployee/AddNewEmployee";
import HRMSReports from "./Hrms/HRMSReports/HRMSReports";
import HRMSAttendance from "./Hrms/HRMSReports/Components/HRMSAttendance";
import HRMSLeaveReport from "./Hrms/HRMSReports/Components/HRMSLeaveReport";
import HRMSLateComers from "./Hrms/HRMSReports/Components/HRMSLateComers";
import HRMSEarlyGoing from "./Hrms/HRMSReports/Components/HRMSEarlyGoing";
import HRMSDeptConsolidated from "./Hrms/HRMSReports/Components/HRMSDeptConsolidated";
import DeviceManagement from "./Hrms/Devices/DeviceManagement";
import EmailLogs from "./Hrms/EmailLogs/EmailLogs";
import HRMSUsers from "./Hrms/HRMSUsers/HRMSUsers";
import Settings from "./Hrms/Settings/Settings";
import ProtectedRoute from "./Routes/ProtectedRoute";
import LeaveManagement from "./Hrms/LeaveManagement/LeaveManagement";
import PayRoll from "./Hrms/PayRoll/PayRoll";
import ReportsDashboard from "./Hrms/HRMSReports/NewHRMSReports/Pages/ReportsDashboard";
import AttendanceReportPage from "./Hrms/HRMSReports/NewHRMSReports/Pages/AttendanceReportPage";
import LateReportPage from "./Hrms/HRMSReports/NewHRMSReports/Pages/LateReportPage";
import EarlyReportPage from "./Hrms/HRMSReports/NewHRMSReports/Pages/EarlyReportPage";
import OutdoorReportPage from "./Hrms/HRMSReports/NewHRMSReports/Pages/OutdoorReportPage";
import MissedReportPage from "./Hrms/HRMSReports/NewHRMSReports/Pages/MissedReportPage";
import ConsolidatedReportPage from "./Hrms/HRMSReports/NewHRMSReports/Pages/ConsolidatedReportPage";
import Dashboard from "./Hrms/UserPortal/Dashboard";
import Profile from "./Hrms/UserPortal/Profile";
import UserAttendance from "./Hrms/UserPortal/UserAttendance";
import PunchLogs from "./Hrms/UserPortal/PunchLogs";
import ApplyLeave from "./Hrms/UserPortal/ApplyLeave";
import LeaveHistory from "./Hrms/UserPortal/LeaveHistory";
import LeaveReportPage from "./Hrms/HRMSReports/NewHRMSReports/Pages/LeaveReportPage";
import CheckInPage from "./Partials/Universal/RoomBook/Components/RoomCheckIn/CheckInPage";
import PayrollDashboard from "./Hrms/PayRoll/Component/PayrollDashboard";
import LoanManagement from "./Hrms/PayRoll/Component/LoanManagement";
import ReimbursementManagement from "./Hrms/PayRoll/Component/ReimbursementManagement";
import SalaryStructure from "./Hrms/PayRoll/Component/SalaryStructure";
import PayrollRun from "./Hrms/PayRoll/Component/PayrollRun";
import PayrollItems from "./Hrms/PayRoll/Component/PayrollItems";
import PayrollFormulas from "./Hrms/PayRoll/Component/PayrollFormulas";
import MonthlyPayrollReport from "./Hrms/PayRoll/Component/MonthlyPayrollReport";
import PayrollSettings from "./Hrms/PayRoll/Component/PayrollSettings";
import PunchIn from "./Hrms/UserPortal/PunchIn";
import ReportsList from "./Partials/Universal/Reports/ReportsList";
import ReportView from "./Partials/Universal/Reports/ReportsView";
import FrontOfficeReports from "./Partials/Universal/Reports/FrontOfficeReports";
import InvoicePreview from "./Partials/Universal/RoomBook/Components/BookingList/InvoicePreview";
import RateTypeList from "./Partials/Universal/Hotels/Components/RateTypeList/RateTypeList";
import BackOfficeReports from "./Partials/Universal/Reports/BackOfficeReports";
import AuditReports from "./Partials/Universal/Reports/AuditReports";
import StatisticalReports from "./Partials/Universal/Reports/StatisticalReports";
import GraphReports from "./Partials/Universal/Reports/GraphReports";
import ReservationReports from "./Partials/Universal/Reports/ReservationReports";
import TaxList from "./Partials/Universal/Hotels/Components/Taxes/TaxList";
import EditReservation from "./Partials/Universal/Reservations/EditReservation";

const Routes = () => {
  return (
    <ReactRoutes>
      {/* For Hotels Tab */}
      <Route element={<ProtectedRoute requiredModule="pms" />}>
        <Route exact path="/" element={<Index />} />
        <Route exact path="/index" element={<Index />} />
        <Route exact path="/my-profile" element={<MyProfile />} />
        <Route exact path="/hotels" element={<Hotels />} />
        <Route exact path="/room-booking" element={<RoomBooking />} />
        <Route
          exact
          path="/room-facilites-list"
          element={<RoomFacilitesList />}
        />
        <Route exact path="/taxes" element={<TaxList />} />
        <Route exact path="/taxes" element={<TaxList />} />
        <Route
          exact
          path="/housekeeping-assign-room"
          element={<HouseKeepingAssignRoom />}
        />
        <Route exact path="/cab-list" element={<CabList />} />
        <Route exact path="/items-list" element={<ItemsList />} />
        <Route
          exact
          path="/personalised-jacuzzi"
          element={<JacuzziBooking />}
        />
        <Route exact path="/booking-report" element={<BookingReport />} />
        <Route exact path="/promocode-list" element={<PromocodeList />} />
        <Route exact path="/transaction" element={<Transaction />} />
        <Route exact path="/room-booking-list" element={<BookingList />} />
        <Route exact path="/checkin-out" element={<RoomCheckout />} />
        <Route exact path="/room-status" element={<RoomStatus />} />
        <Route
          exact
          path="/facilites-details"
          element={<FacilitesDetailsList />}
        />
        <Route exact path="/room-size" element={<RoomSize />} />
        <Route
          exact
          path="/housekeeping-roomcleaning"
          element={<RoomCleaning />}
        />
        <Route exact path="/housekeeping-checklist" element={<Checklist />} />
        <Route exact path="/housekeeping-qrlist" element={<QrList />} />
        <Route exact path="/housekeeping-report" element={<CleaningReport />} />
        <Route exact path="/cab-booking" element={<CabBooking />} />
        <Route exact path="/items-unit-list" element={<ItemsUnitList />} />
        <Route
          exact
          path="/items-destroyed-list"
          element={<ItemsDestroyed />}
        />
        <Route exact path="/items-category-list" element={<ItemsCategory />} />
        <Route
          exact
          path="/items-suppliers-list"
          element={<ItemsSuppliers />}
        />
        <Route exact path="/personalised" element={<Personalised />} />
        <Route
          exact
          path="/personalised-swimmingpool"
          element={<SwimmingPool />}
        />
        <Route exact path="/personalised-spa" element={<Spa />} />
        <Route exact path="/personalised-pedicure" element={<Pedicure />} />
        <Route exact path="/personalised-theater" element={<Theater />} />
        <Route exact path="/personalised-banquet" element={<Banquet />} />
        <Route exact path="/personalised-settings" element={<AllSettings />} />
        <Route exact path="/purchase-report" element={<PurchaseReports />} />
        <Route exact path="/invoice" element={<Invoice />} />
        <Route exact path="/stock-report" element={<StockReport />} />
        <Route exact path="/bed-list" element={<BedList />} />
        <Route exact path="/booking-type-list" element={<BookingTypeList />} />
        <Route exact path="/commission-list" element={<BookingCommission />} />
        <Route
          exact
          path="/complementary-list"
          element={<ComplementaryList />}
        />
        <Route exact path="/floor-plan-list" element={<FloorPlanList />} />
        <Route exact path="/room-list" element={<RoomList />} />
        <Route exact path="/room-type" element={<RoomType />} />
        <Route exact path="/rate-type" element={<RateTypeList />} />
        <Route exact path="/rate-type" element={<RateTypeList />} />
        <Route exact path="/room-image" element={<RoomImages />} />
        <Route exact path="/calender-view" element={<CalendarView />} />
        <Route path="/reservation/:id/check-in" element={<CheckInPage />} />

        <Route exact path="/room-view" element={<RoomView />} />
        <Route exact path="/guest-database" element={<GuestDatabase />} />
        <Route exact path="/night-audit" element={<NightAudit />} />
        <Route
          exact
          path="/edit-guest-database"
          element={<EditGuestDatabase />}
        />
        <Route exact path="/pos" element={<POS />} />
        <Route exact path="/kot" element={<KOT />} />
        <Route exact path="/revenue" element={<Revenue />} />
        <Route exact path="/reports" element={<Reports />} />
        <Route
          path="/reservation/:id/invoice-preview"
          element={<InvoicePreview />}
        />
        <Route
          path="/reservations/edit/:reservationId"
          element={<EditReservation />}
        />

        <Route path="/reports/:category" element={<ReportsList />} />
        <Route path="/reports/:category/:report" element={<ReportView />} />
        <Route
          path="/reports/front-office-report"
          element={<FrontOfficeReports />}
        />
        <Route
          path="/reports/back-office-report"
          element={<BackOfficeReports />}
        />
        <Route path="/reports/audit-report" element={<AuditReports />} />
        <Route
          path="/reports/statistical-report"
          element={<StatisticalReports />}
        />
        <Route path="/reports/graphs-charts" element={<GraphReports />} />
        <Route
          path="/reports/reservation-report"
          element={<ReservationReports />}
        />
        <Route
          path="/reports/front-office-report"
          element={<FrontOfficeReports />}
        />
        <Route
          path="/reports/back-office-report"
          element={<BackOfficeReports />}
        />
        <Route path="/reports/audit-report" element={<AuditReports />} />
        <Route
          path="/reports/statistical-report"
          element={<StatisticalReports />}
        />
        <Route path="/reports/graphs-charts" element={<GraphReports />} />
        <Route
          path="/reports/reservation-report"
          element={<ReservationReports />}
        />
      </Route>

      {/* For Hrms Tab */}
      <Route element={<ProtectedRoute requiredModule="hrms" />}>
        <Route exact path="/index-hr" element={<IndexHr />} />
        <Route exact path="/hrms" element={<Hrms />} />
        <Route exact path="/employees-add" element={<AddEmployees />} />
        <Route exact path="/employees-leave" element={<LeaveRequest />} />
        <Route exact path="/employee-profile" element={<EmployeeProfile />} />
        <Route
          exact
          path="/duty-assigned-list"
          element={<AssignedEmployeeList />}
        />
        <Route exact path="/employees-attendance" element={<Attendance />} />
        <Route
          exact
          path="/payroll-employee-salary"
          element={<EmployeeSalary />}
        />
        <Route exact path="/payroll-report" element={<PayrollReport />} />
        <Route
          exact
          path="/employees-departments"
          element={<EmployeesDepartments />}
        />
        <Route exact path="/duty-shift-list" element={<ShiftList />} />
        <Route exact path="/duty-roster-list" element={<RosterList />} />
        <Route exact path="/employees-all" element={<AllEmployees />} />
        <Route exact path="/employees-loan" element={<EmployeeLoan />} />
        <Route
          exact
          path="/employees-appraisal"
          element={<EmployeeAppraisal />}
        />
        <Route exact path="/payroll-payslip" element={<PaySlip />} />

        <Route exact path="/hrms-dashboard" element={<HRMSDashboard />} />
        <Route exact path="/live-logs" element={<LiveLogs />} />
        <Route exact path="/audit" element={<Audit />} />
        <Route exact path="/duty-roster" element={<DutyRoster />} />
        <Route exact path="/employee-management" element={<AddNewEmployee />} />
        <Route exact path="/leave-management" element={<LeaveManagement />} />
        <Route exact path="/hrms-reports" element={<HRMSReports />} />
        <Route exact path="/payroll" element={<PayRoll />} />
        <Route
          exact
          path="/hrms-reports/hrms-attendance"
          element={<HRMSAttendance />}
        />
        <Route
          exact
          path="/hrms-reports/hrms-leave-report"
          element={<HRMSLeaveReport />}
        />
        <Route
          exact
          path="/hrms-reports/late-comers"
          element={<HRMSLateComers />}
        />
        <Route
          exact
          path="/hrms-reports/early-going"
          element={<HRMSEarlyGoing />}
        />
        <Route
          exact
          path="/hrms-reports/department-consolidated"
          element={<HRMSDeptConsolidated />}
        />

        <Route exact path="/hrms-dashboard" element={<HRMSDashboard />} />
        <Route exact path="/attendance" element={<SubAttendance />} />
        <Route exact path="/live-logs" element={<LiveLogs />} />
        <Route exact path="/audit" element={<Audit />} />
        <Route exact path="/duty-roster" element={<DutyRoster />} />
        <Route exact path="/employee-management" element={<AddNewEmployee />} />
        <Route exact path="/hrms-reports" element={<HRMSReports />} />
        <Route
          exact
          path="/hrms-reports/hrms-attendance"
          element={<HRMSAttendance />}
        />
        <Route
          exact
          path="/hrms-reports/hrms-leave-report"
          element={<HRMSLeaveReport />}
        />
        <Route
          exact
          path="/hrms-reports/late-comers"
          element={<HRMSLateComers />}
        />
        <Route
          exact
          path="/hrms-reports/early-going"
          element={<HRMSEarlyGoing />}
        />
        <Route
          exact
          path="/hrms-reports/department-consolidated"
          element={<HRMSDeptConsolidated />}
        />
        <Route exact path="/devices" element={<DeviceManagement />} />
        <Route exact path="/email-logs" element={<EmailLogs />} />
        {/* <Route exact path="/users" element={<HRMSUsers />} /> */}
        <Route exact path="/settings" element={<Settings />} />

        {/* For Tuning Tab */}
        <Route exact path="/tuning" element={<Tuning />} />
        <Route exact path="/common-settings" element={<CommonSettings />} />
        <Route exact path="/payment-set" element={<PaymentSettings />} />
        <Route exact path="/accounts-setting" element={<AccountSettings />} />
        <Route exact path="/role-add" element={<RoleAdd />} />
        <Route exact path="/app" element={<Apps />} />
        <Route exact path="/inbox" element={<Inbox />} />
        <Route exact path="/chat" element={<Chat />} />
        <Route exact path="/calendar" element={<Calendar />} />
        <Route exact path="/filemanager" element={<FileManager />} />
        <Route exact path="/changelog" element={<Changelog />} />
        <Route exact path="/role-list" element={<RoleList />} />
        <Route exact path="/role-permission" element={<RolePermission />} />
        <Route exact path="/role-create-list" element={<RoleCreate />} />
        <Route exact path="/role-assign" element={<RoleAssign />} />
        <Route exact path="/role-access-list" element={<RoleAccess />} />
        <Route exact path="/about-us" element={<AboutUs />} />
        <Route exact path="/contact-us" element={<ContactUs />} />
        <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route exact path="/terms-conditions" element={<TermsConditions />} />
        <Route exact path="/blog" element={<Blog />} />
        <Route exact path="/blog-detail" element={<BlogDetail />} />
        <Route exact path="/search" element={<SearchPage />} />

        <Route path="/reports" element={<ReportsDashboard />} />
        <Route path="/reports/attendance" element={<AttendanceReportPage />} />
        <Route path="/reports/late" element={<LateReportPage />} />
        <Route path="/reports/early" element={<EarlyReportPage />} />
        <Route path="/reports/outdoor" element={<OutdoorReportPage />} />
        <Route path="/reports/missed" element={<MissedReportPage />} />
        <Route
          path="/reports/consolidated"
          element={<ConsolidatedReportPage />}
        />
        <Route path="/reports/leave" element={<LeaveReportPage />} />
        <Route path="/payroll/dashboard" element={<PayrollDashboard />} />
        <Route path="/payroll/loans" element={<LoanManagement />} />
        <Route
          path="/payroll/reimbursements"
          element={<ReimbursementManagement />}
        />
        <Route path="/payroll/salary-structure" element={<SalaryStructure />} />
        <Route path="/payroll/payroll-run" element={<PayrollRun />} />
        <Route path="/payroll/payroll-items" element={<PayrollItems />} />
        <Route path="/payroll/payroll-formulas" element={<PayrollFormulas />} />
        <Route path="/payroll/reports" element={<MonthlyPayrollReport />} />
        <Route path="/payroll/settings" element={<PayrollSettings />} />
      </Route>

      <Route>
        <Route exact path="/users" element={<HRMSUsers />} />
      </Route>

      <Route
        element={
          <ProtectedRoute requiredModule="hrms" requiredRole="employee" />
        }
      >
        <Route path="/user/dashboard" element={<Dashboard />} />
        <Route path="/user/profile" element={<Profile />} />
        <Route path="/user/attendance" element={<UserAttendance />} />
        <Route path="/user/punches" element={<PunchLogs />} />
        <Route path="/user/leave/apply" element={<ApplyLeave />} />
        <Route path="/user/leave/history" element={<LeaveHistory />} />
        <Route path="/user/punch-in" element={<PunchIn />} />
      </Route>
    </ReactRoutes>
  );
};

export default Routes;
